// Satu daftar buat semua kartu di halaman Configuration.

export const masterGroups = [
  {
    title: 'General',
    colorClass: 'color-general',
    items: [
      {
        title: 'Asset',
        to: { name: 'Asset' },
        permission: 'master_asset',
        icon: 'ri-ship-2-line',
      },
      {
        title: 'Device',
        to: { name: 'Device' },
        permission: 'master_device',
        icon: 'ri-remote-control-line',
      },
      {
        title: 'Landmarks',
        to: { name: 'Landmarks' },
        permission: 'master_landmark',
        icon: 'ri-road-map-line',
      },
    ],
  },
  {
    title: 'User Management',
    colorClass: 'color-user-management',
    items: [
      {
        title: 'Users List',
        to: { name: 'User' },
        permission: 'master_user',
        icon: 'ri-user-line',
      },
      {
        title: 'Role',
        to: { name: 'Role' },
        permission: 'master_role',
        icon: 'ri-shield-user-line',
      },
      {
        title: 'Permission',
        to: { name: 'Permission' },
        permission: 'master_permission',
        icon: 'ri-key-2-line',
      },
    ],
  },
  {
    title: 'Company & Asset',
    colorClass: 'color-company-asset',
    items: [
      {
        title: 'Group',
        to: { name: 'Group' },
        permission: 'master_group_company',
        icon: 'ri-group-2-line',
      },
      {
        title: 'Company',
        to: { name: 'Company' },
        permission: 'master_company',
        icon: 'ri-building-4-line',
      },
      {
        title: 'Asset Type',
        to: { name: 'MasterAssetType' },
        permission: 'master_asset_type',
        icon: 'ri-ship-line',
      },
    ],
  },
  {
    title: 'Sensors & Tanks',
    colorClass: 'color-sensors-tanks',
    items: [
      {
        title: 'Sensor Type',
        to: { name: 'MasterSensorType' },
        permission: 'master_sensor_type',
        icon: 'ri-sensor-line',
      },
      {
        title: 'Sensor Category',
        to: { name: 'MasterSensorCategory' },
        permission: 'master_sensor_category',
        icon: 'ri-file-list-3-line',
      },
      {
        title: 'Tank Header/Detail',
        to: { name: 'MasterTank' },
        permission: 'master_tank_header',
        icon: 'ri-database-2-line',
      },
    ],
  },
  {
    title: 'Bunkering & Fuel',
    colorClass: 'color-bunkering-fuel',
    items: [
      {
        title: 'Fuel Type',
        to: { name: 'MasterFuelType' },
        permission: 'master_fuel_type',
        icon: 'ri-gas-station-line',
      },
      {
        title: 'Bunker Location',
        to: { name: 'MasterBunkerLocation' },
        permission: 'master_bunker_location',
        icon: 'ri-map-pin-line',
      },
    ],
  },
  {
    title: 'System Configuration',
    colorClass: 'color-system-config',
    items: [
      {
        title: 'Config RPM',
        to: { name: 'MasterConfigRpm' },
        permission: 'master_config_rpm',
        icon: 'ri-speed-up-line',
      },
      {
        title: 'Config AE',
        to: { name: 'MasterConfigAe' },
        permission: 'master_config_ae',
        icon: 'ri-sound-module-line',
      },
      {
        title: 'Config Tank',
        to: { name: 'MasterConfigTank' },
        permission: 'master_config_tank',
        icon: 'ri-database-line',
      },
      {
        title: 'RPM Classification',
        to: '/master/rpm-classification',
        permission: 'master_rpm_operation_header',
        icon: 'ri-settings-3-line',
      },
    ],
  },
  {
    title: 'Events',
    colorClass: 'color-events',
    items: [
      {
        title: 'Master Event',
        to: { name: 'MasterEvent' },
        permission: 'master_events',
        icon: 'ri-alarm-warning-line',
      },
      {
        title: 'Config Event',
        to: { name: 'MasterConfigEvent' },
        permission: 'master_config_event',
        icon: 'ri-notification-badge-line',
      },
    ],
  },
  {
    title: 'Notification',
    colorClass: 'color-notification',
    items: [
      {
        title: 'Notification Settings',
        to: { name: 'MasterNotificationSettings' },
        permission: [
          'master_notification_topic',
          'master_notification_template',
          'master_notification_contact',
          'master_notification_subscription',
        ],
        icon: 'ri-notification-3-line',
      },
      {
        title: 'Notification Recipient',
        to: { name: 'NotificationRecipient' },
        permission: 'master_notification_recipient',
        icon: 'ri-mail-settings-line',
      },
      {
        title: 'Event Notification Rule',
        to: { name: 'EventNotificationRule' },
        permission: 'master_event_notification_rule',
        icon: 'ri-notification-4-line',
      },
    ],
  },
  {
    title: 'Daily Report',
    colorClass: 'color-daily-report',
    items: [
      {
        title: 'Daily Report',
        to: { name: 'ReportTarget' },
        permission: 'master_report_target',
        icon: 'ri-file-list-3-line',
      },
    ],
  },
];

export const masters = masterGroups.reduce((all, group) => all.concat(group.items), []);
